"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Search = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var Icon_styled_1 = require("../Icon.styled");
exports.Search = function (props) { return (React.createElement(Icon_styled_1.StyledSvg, tslib_1.__assign({}, props, { width: "22", height: "21", viewBox: "0 0 22 21", fill: "none" }),
    React.createElement("circle", { cx: "8.07692", cy: "8.07692", r: "6.57692", stroke: props.stroke, strokeWidth: "3" }),
    React.createElement("line", { x1: "14.2385", y1: "13.7305", x2: "19.3864", y2: "18.8784", stroke: props.stroke, strokeWidth: "3", strokeLinecap: "round" }))); };
//# sourceMappingURL=search.js.map